import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ClientDetails } from '../../../models/client/client-details';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { SearchUserMasterService } from '../../../proxies/user-master/search-user-master.service';
import { MasterData } from '@card-software/nexus-utilities';
import { UserMaster } from '../../../models/user-master/user-master';
import { MasterDataProxyService } from '../../../proxies/master-data.proxy.service';
import { Observable, map } from 'rxjs';

@Component({
  selector: 'app-client-details-viewer',
  templateUrl: './client-details-viewer.component.html',
})
export class ClientDetailsViewerComponent implements OnInit {
  @Output() clientChange = new EventEmitter<ClientDetails>();
  @Input() client: ClientDetails | null = null;
  @Input() viewOnly = false;

  paymentTermsCategoryCode = '';

  leadAssociateUserName = new FormControl<UserMaster | null>(null);
  clientForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private confirmationService: ConfirmationService,
    private searchUserMasterService: SearchUserMasterService,
    private masterDataProxyService: MasterDataProxyService,
  ) {
    this.clientForm = this.fb.group({
      clientClassificationCode: [''],
      industryCode: [''],
      salesOrganizationCode: [''],
      distributionChannelCode: [''],
      divisionCode: [''],
      paymentTermsCode: [''],
      accountGroupCode: [''],
      clientBlockReasonCode: [''],
      sgiCode: [''],
      cisCode: [''],
      overagePercentage: [null],
      shortagePercentage: [null],
    });
  }

  ngOnInit(): void {
    if (this.client) {
      this.populateData(this.client);
    }

    if (this.viewOnly) {
      this.clientForm.disable();
    }

    this.clientForm.valueChanges.subscribe(() => {
      this.emitClient();
    });
  }

  populateData(client: ClientDetails) {
    this.clientForm.setValue({
      clientClassificationCode: client.clientClassificationCode,
      industryCode: client.industryCode,
      salesOrganizationCode: client.salesOrganizationCode,
      distributionChannelCode: client.distributionChannelCode,
      divisionCode: client.divisionCode,
      paymentTermsCode: client.paymentTermsCode,
      accountGroupCode: client.accountGroupCode,
      clientBlockReasonCode: client.clientBlockReasonCode,
      sgiCode: client.sgiCode,
      cisCode: client.cisCode,
      overagePercentage: client.overagePercentage ?? null,
      shortagePercentage: client.shortagePercentage ?? null,
    });
  }

  deleteItemMasterData(item: { item: MasterData; confirmCallback: () => void; cancelCallback: () => void }) {
    this.confirmationService.confirm({
      message: `Are you sure you want to delete item?`,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      key: 'ct',
      accept: () => {
        item.confirmCallback();
      },
      reject: () => {
        item.cancelCallback();
      },
    });
  }

  public fetchLeadAssociates = (query: string): Observable<UserMaster[]> =>
    this.searchUserMasterService.getUserByUserName(query.toLowerCase()).pipe(map(({ data }) => (data ? [data] : [])));

  emitClient() {
    const formValue = this.clientForm.getRawValue();
    const clientDetails: ClientDetails = {
      clientClassificationCode: formValue.clientClassificationCode || undefined,
      industryCode: formValue.industryCode || undefined,
      salesOrganizationCode: formValue.salesOrganizationCode || undefined,
      distributionChannelCode: formValue.distributionChannelCode || undefined,
      divisionCode: formValue.divisionCode || undefined,
      paymentTermsCode: formValue.paymentTermsCode || undefined,
      accountGroupCode: formValue.accountGroupCode || undefined,
      clientBlockReasonCode: formValue.clientBlockReasonCode || undefined,
      sgiCode: formValue.sgiCode || formValue.sgiCode === 0 ? Number(formValue.sgiCode) : undefined,
      cisCode: formValue.cisCode || formValue.cisCode === 0 ? Number(formValue.cisCode) : undefined,
      leadAssociateUserName: formValue.leadAssociateUserName || undefined,
      overagePercentage: formValue.overagePercentage || formValue.overagePercentage === 0 ? Number(formValue.overagePercentage) : undefined,
      shortagePercentage:
        formValue.shortagePercentage || formValue.shortagePercentage === 0 ? Number(formValue.shortagePercentage) : undefined,
    };
    this.clientChange.emit(clientDetails);
  }
}
